import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=2cba25a2"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports